/* Lightbox = one-media-at-a-time carousel. Opens on the clicked media, prev/next + arrow keys to
 * navigate, and the video autoplays whenever it becomes the active slide. build=2026-06-17-v2 */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.pauseAllVideos();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.items = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        this.bindNav();
        const opened = this.openedBy && this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActive(opened || this.items[0]);
      }

      bindNav() {
        if (this._navBound) return;
        this._navBound = true;
        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        // stopPropagation so the arrow click doesn't bubble to the modal's click-to-close handler.
        if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.navigate(-1); });
        if (next) next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.navigate(1); });
        // The media-modal closes on `pointerup` (mouse) anywhere outside a video/model — so the
        // arrows would close it too. Stop pointerup/pointerdown on them so navigation wins.
        [prev, next].forEach((b) => {
          if (!b) return;
          b.addEventListener('pointerup', (e) => e.stopPropagation());
          b.addEventListener('pointerdown', (e) => e.stopPropagation());
        });
        // Close on background click only — clicking the IMAGE should NOT close (video is already
        // excluded by the theme). Stop pointerup on the media images so only the backdrop closes.
        this.querySelectorAll('.product-media-modal__content img').forEach((img) => {
          img.addEventListener('pointerup', (e) => e.stopPropagation());
        });
        // Swipe left/right to navigate on touch devices.
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          let sx = 0, sy = 0;
          content.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
          content.addEventListener('touchend', (e) => {
            const dx = e.changedTouches[0].clientX - sx;
            const dy = e.changedTouches[0].clientY - sy;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.navigate(dx < 0 ? 1 : -1);
          }, { passive: true });
        }
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.navigate(-1);
          else if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      navigate(dir) {
        if (!this.items || this.items.length < 2) return;
        const idx = this.items.findIndex((i) => i.classList.contains('active'));
        let n = idx + dir;
        if (n < 0) n = this.items.length - 1;
        if (n >= this.items.length) n = 0;
        this.setActive(this.items[n]);
      }

      setActive(activeMedia) {
        if (!activeMedia) return;
        this.pauseAllVideos();
        this.items.forEach((i) => i.classList.remove('active'));
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest' });
        this.playActiveVideo(activeMedia);
        // hide arrows when there's only one media
        const nav = this.querySelectorAll('.product-media-modal__nav');
        nav.forEach((b) => { b.hidden = this.items.length < 2; });
      }

      playActiveVideo(activeMedia) {
        if (activeMedia.nodeName !== 'DEFERRED-MEDIA') return;
        const existing = activeMedia.querySelector('video, iframe');
        if (!existing && typeof activeMedia.loadContent === 'function') {
          activeMedia.loadContent(false); // injects the <template> video (autoplay:true)
        } else if (existing && existing.nodeName === 'VIDEO') {
          existing.play().catch(() => {});
        }
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((v) => {
          try { v.pause(); } catch (_) {}
        });
      }
    }
  );
}
